<template>
  <div>
    <section class="section-padding bg-white">
      <div class="container-width">
        <div class="text-center mb-16">
          <h1 class="text-dark-900 mb-4">Werdegang</h1>
          <p class="text-xl text-dark-600 max-w-3xl mx-auto">
            Meine berufliche Entwicklung und Stationen
          </p>
        </div>

        <!-- Timeline -->
        <div class="max-w-4xl mx-auto">
          <div v-for="(item, index) in timeline" :key="index" class="relative pl-8 pb-12 border-l-2 border-primary-200 last:pb-0">
            <div class="absolute left-0 top-0 -translate-x-1/2 w-4 h-4 rounded-full bg-primary-500"></div>
            <div class="bg-gray-50 p-6 rounded-lg">
              <div class="flex flex-wrap gap-2 mb-2">
                <span class="text-sm font-medium text-primary-600">{{ item.period }}</span>
                <span class="text-sm text-dark-500">{{ item.type }}</span>
              </div>
              <h3 class="text-xl font-bold text-dark-900 mb-1">{{ item.title }}</h3>
              <p class="text-dark-700 font-medium mb-2">{{ item.company }}</p>
              <p class="text-dark-600">{{ item.description }}</p>
            </div>
          </div>
        </div>

        <!-- Download-Bereich -->
        <div class="max-w-4xl mx-auto mt-16 pt-12 border-t border-gray-200 text-center">
          <p class="text-dark-600 mb-6">Alle Unterlagen als PDF herunterladen</p>
          <div class="flex flex-wrap justify-center gap-4">
            <a
              href="/downloads/Enrico Reinsdorf–UX Portfolio-20260301.pdf"
              download
              class="px-8 py-3 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors font-medium"
            >
              Portfolio herunterladen
            </a>
            <a
              href="/downloads/Enrico Reinsdorf Lebenslauf.pdf"
              download
              class="px-8 py-3 border-2 border-primary-500 text-primary-500 rounded-lg hover:bg-primary-50 transition-colors font-medium"
            >
              Lebenslauf herunterladen
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
useHead({
  title: 'Werdegang - Beruflicher Hintergrund | Enrico Reinsdorf',
  meta: [
    { name: 'description', content: 'Beruflicher Werdegang: AKDB, BRZ Deutschland, ASTRUM IT, ERGO Direkt, chilli mind. Über 10 Jahre Erfahrung als Senior UX Designer und Usability Engineer.' },
    { name: 'keywords', content: 'Berufserfahrung UX Designer, AKDB, BRZ, ERGO Direkt, CPUX-F' }
  ]
})

const timeline = [
  {
    period: 'März 2024 - heute',
    type: 'Festanstellung',
    title: 'Senior UX Designer',
    company: 'AKDB',
    description: 'Unterstützung bei der Entwicklung von OK.PERS+ durch User Research, Konzeption und Usability Testing.'
  },
  {
    period: 'Januar 2021 - Februar 2024',
    type: 'Festanstellung',
    title: 'Senior User Experience Designer',
    company: 'BRZ Deutschland GmbH',
    description: 'Unterstützung bei der Entwicklung von BRZ 365 und Konzeption sowie Erstellung eines Design Systems.'
  },
  {
    period: 'Dezember 2019 - Dezember 2020',
    type: 'Festanstellung',
    title: 'Usability Engineer',
    company: 'ASTRUM IT GmbH',
    description: 'Fachliche Team-Führung und Usability Engineering beim IT-Systemhaus für die Bundesagentur für Arbeit.'
  },
  {
    period: 'November 2017 - November 2019',
    type: 'Festanstellung',
    title: 'Referent für User Experience / Product Owner',
    company: 'ERGO Direkt AG',
    description: 'User Experience Design und Product Ownership für digitale Versicherungslösungen in agilen Teams.'
  },
  {
    period: 'November 2016 - September 2017',
    type: 'Festanstellung',
    title: 'Senior UX Designer',
    company: 'chilli mind GmbH',
    description: 'Senior UX Designer mit Fokus auf nutzerzentrierte Produktentwicklung.'
  },
  {
    period: 'Dezember 2014 - Oktober 2016',
    type: 'Festanstellung',
    title: 'Webdesign und -entwickler (Frontend)',
    company: 'Flavia IT-Management GmbH',
    description: 'Software-Entwicklung, anwenderzentriertes Frontend-Design, Webdesign und UI- & UX-Design.'
  },
  {
    period: 'März 1996 - April 2014',
    type: 'Freelance',
    title: 'Webentwickler und Trainer',
    company: 'RE-Design',
    description: 'Webentwicklung (HTML5/CSS3, JavaScript, PHP/mySQL, Zend Framework 2), Anwendungsentwicklung (Flash, ActionScript3, Apache Flex), Maxon Cinema4D, Videoschnitt & Postproduktion (Adobe Premiere/AfterEffects).'
  },
  {
    period: '1996 - 2014',
    type: 'Freelance',
    title: 'Freier Dozent und Supervisor',
    company: 'Verschiedene Bildungsträger',
    description: 'Langjährige Lehrtätigkeit als freier Dozent bei SAE Institute, medienreich Computertrainings, KW Trainingszentrum, VSB Bildungswerk und weiteren Bildungsträgern. Schwerpunkte: HTML/CSS, JavaScript, PHP, Flash, ActionScript, Cinema4D, Adobe Creative Suite.'
  },
  {
    period: '2011 - 2014',
    type: 'Ausbildung',
    title: 'Bachelor of Arts - Mediendesign',
    company: 'Hochschule Hof',
    description: 'Studium an der University of Applied Sciences mit Schwerpunkt Mediendesign.'
  },
  {
    period: '2000 - 2001',
    type: 'Ausbildung',
    title: 'Diploma - Multimedia Producer',
    company: 'SAE College',
    description: 'Ausbildung zum Multimedia Producer am SAE College.'
  }
]
</script>
